import { render, staticRenderFns } from "./markdown-component.vue?vue&type=template&id=08769b5b"
import script from "./markdown-component.vue?vue&type=script&lang=js"
export * from "./markdown-component.vue?vue&type=script&lang=js"
import style0 from "./markdown-component.vue?vue&type=style&index=0&id=08769b5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports